export default __webpack_public_path__ + "static/media/arrow.5d215a10.jpg";